import React, { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Inputs from "../components/Inputs";
import { Link, useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa6";
import { toast } from "react-toastify";
import api from "../utilis/api";
import { useDispatch } from "react-redux";
import { login } from "../redux/store/userSlice";
const Auth = () => {
  const [mode, setMode] = useState("login"); // "login" | "register"
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (mode === "login") {
        const response = await api.post("/auth/sign-in", form);

        if (response.data?.meta?.success) {
          toast.success(response.data.meta.message, { autoClose: 3000 });
          dispatch(
            login({
              user: response.data.data.user,
              token: response.data.data.token,
            }),
          );
          navigate("/user");
        } else {
          toast.error(response.data?.meta?.message || "Login failed", {
            autoClose: 4000,
          });
        }
      } else {
        const register = await api.post("/auth/sign-up", form);
        console.log(register.data);
        if (register.data) {
          toast.success("User registered successfully");

          setTimeout(() => {
            setMode("login");
          }, 1500);
        } else {
          toast.error(register.data?.meta?.message || "Registration failed", {
            autoClose: 4000,
          });
        }
      }
      setForm({
        name: "",
        email: "",
        phone: "",
        password: "",
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  return (
    <>
      {/* <Topbar/> */}
      {/* <div className="bg-black"> */}
      <Navbar />
      {/* </div> */}

      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
          {/* Title */}
          <h2 className="text-2xl font-bold text-center mb-6">
            {mode === "login" ? "Welcome Back" : "Create Account"}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Show Name only in Register */}
            {mode === "register" && (
              <Inputs
                label="Full Name"
                name="name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Enter your full name"
              />
            )}

            <Inputs
              label="Email"
              type="email"
              name="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Enter your email"
            />
            {mode === "register" && (
              <Inputs
                label="Phone"
                name="number"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                placeholder="Enter your phone number"
              />
            )}
            <Inputs
              label="Password"
              type="password"
              name="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Enter your password"
            />
            <div className="mt-[1rem]">
              {mode === "login" && (
                <a
                  href="/forget-password"
                  className="text-blue-600 font-medium hover:underline"
                >
                  Forget Password
                </a>
              )}
            </div>
            <button
              type="submit"
              className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition"
            >
              {mode === "login" ? "Signin" : "Signup"}
            </button>
          </form>
          <div className="mt-6 text-center">
            <p className="text-[16px] text-gray-500">
              Or {mode === "login" ? "signin" : "signup"} with
            </p>
            <div className="mt-[1rem] flex justify-center items-cener gap-[1rem]">
              <FcGoogle size={25} className="cursor-pointer" />
              <FaFacebook
                size={25}
                color="#1877F2"
                className="cursor-pointer"
              />
            </div>
          </div>
          {/* Toggle Section */}
          <div className="mt-6 text-center text-sm text-gray-500">
            {mode === "login" ? (
              <>
                Don't have an account?{" "}
                <button
                  onClick={() => setMode("register")}
                  className="text-blue-600 font-medium hover:underline"
                >
                  Signup
                </button>
              </>
            ) : (
              <>
                Already have an account?{" "}
                <button
                  onClick={() => setMode("login")}
                  className="text-blue-600 font-medium hover:underline "
                >
                  Signin
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Auth;
